import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { useUserContext } from "../../context/UserContext";
import DropdownMenu from "./DropdownMenu.jsx";

export default function SelectScenario() {
  const {
    isTesting,
    scenarios,
    scenario,
    setScenario,
    subscenario,
    setSubscenario,
    flushType,
    setFlushType,
    deviceCapabilities,
  } = useUserContext();
  const [expandScenario, setExpandScenario] = useState(false);
  const [expandSubScenario, setExpandSubScenario] = useState(false);
  const [expandType, setExpandType] = useState(false);
  const scenarioRef = useRef(null);
  const subScenarioRef = useRef(null);
  const typeRef = useRef(null);

  const checkRequestOptions =
    scenario === "check_request" &&
    Array.isArray(deviceCapabilities?.checkRequestSubscenarios)
      ? deviceCapabilities.checkRequestSubscenarios
      : scenarios[scenario] || [];

  const masterOptions =
    scenario === "master" &&
    Array.isArray(deviceCapabilities?.masterSubscenarios) &&
    deviceCapabilities.masterSubscenarios.length > 0
      ? deviceCapabilities.masterSubscenarios
      : scenario === "master" &&
          Array.isArray(deviceCapabilities?.supportedFlushes) &&
          deviceCapabilities.supportedFlushes.length > 0
        ? deviceCapabilities.supportedFlushes
        : scenarios[scenario] || [];

  const terminationOptions =
    scenario === "termination" &&
    Array.isArray(deviceCapabilities?.terminationSubscenarios) &&
    deviceCapabilities.terminationSubscenarios.length > 0
      ? deviceCapabilities.terminationSubscenarios
      : scenario === "termination" &&
          Array.isArray(deviceCapabilities?.supportedFlushes) &&
          deviceCapabilities.supportedFlushes.length > 0
        ? [...deviceCapabilities.supportedFlushes, "master_program"]
        : scenarios[scenario] || [];

  const emergencyOptions =
    scenario === "emergency" &&
    Array.isArray(deviceCapabilities?.emergencySubscenarios) &&
    deviceCapabilities.emergencySubscenarios.length > 0
      ? deviceCapabilities.emergencySubscenarios
      : scenarios.emergency || [];

  const pulseOptions =
    scenario === "pulse_calibration" &&
    Array.isArray(deviceCapabilities?.pulseCalibrationSubscenarios) &&
    deviceCapabilities.pulseCalibrationSubscenarios.length > 0
      ? deviceCapabilities.pulseCalibrationSubscenarios
      : scenarios.pulse_calibration || [];

  const subScenarioOptions =
    scenario === "check_request"
      ? checkRequestOptions
      : scenario === "master"
        ? masterOptions
        : scenario === "termination"
          ? terminationOptions
          : scenario === "emergency"
            ? emergencyOptions
            : scenario === "pulse_calibration"
              ? pulseOptions
              : scenarios[scenario] || [];

  useEffect(() => {
    if (isTesting) {
      setExpandScenario(false);
      setExpandSubScenario(false);
      setExpandType(false);
    }
  }, [isTesting]);

  useEffect(() => {
    if (
      scenario !== "check_request" &&
      scenario !== "master" &&
      scenario !== "termination" &&
      scenario !== "emergency" &&
      scenario !== "pulse_calibration"
    ) {
      return;
    }
    const opts =
      scenario === "check_request"
        ? deviceCapabilities?.checkRequestSubscenarios
        : scenario === "master"
          ? deviceCapabilities?.masterSubscenarios ||
            deviceCapabilities?.supportedFlushes
          : scenario === "termination"
            ? deviceCapabilities?.terminationSubscenarios ||
              (Array.isArray(deviceCapabilities?.supportedFlushes)
                ? [...deviceCapabilities.supportedFlushes, "master_program"]
                : null)
            : scenario === "emergency"
              ? deviceCapabilities?.emergencySubscenarios
              : deviceCapabilities?.pulseCalibrationSubscenarios;
    if (!Array.isArray(opts) || opts.length === 0) return;
    if (subscenario && !opts.includes(subscenario)) {
      setSubscenario(opts[0]);
    }
  }, [scenario, subscenario, deviceCapabilities, setSubscenario]);

  function changeScenario(nextScenario) {
    setScenario(nextScenario);
    if (nextScenario === "check_request") {
      const opts =
        Array.isArray(deviceCapabilities?.checkRequestSubscenarios) &&
        deviceCapabilities.checkRequestSubscenarios.length > 0
          ? deviceCapabilities.checkRequestSubscenarios
          : scenarios[nextScenario] || [];
      setSubscenario(opts[0] || "sed_flush");
    } else if (nextScenario === "master") {
      const opts =
        Array.isArray(deviceCapabilities?.masterSubscenarios) &&
        deviceCapabilities.masterSubscenarios.length > 0
          ? deviceCapabilities.masterSubscenarios
          : Array.isArray(deviceCapabilities?.supportedFlushes) &&
              deviceCapabilities.supportedFlushes.length > 0
            ? deviceCapabilities.supportedFlushes
            : scenarios[nextScenario] || [];
      setSubscenario(opts[0] || "sed_flush");
    } else if (nextScenario === "termination") {
      const opts =
        Array.isArray(deviceCapabilities?.terminationSubscenarios) &&
        deviceCapabilities.terminationSubscenarios.length > 0
          ? deviceCapabilities.terminationSubscenarios
          : Array.isArray(deviceCapabilities?.supportedFlushes) &&
              deviceCapabilities.supportedFlushes.length > 0
            ? [...deviceCapabilities.supportedFlushes, "master_program"]
            : scenarios[nextScenario] || [];
      setSubscenario(opts[0] || "sed_flush");
    } else if (nextScenario === "emergency") {
      const opts =
        Array.isArray(deviceCapabilities?.emergencySubscenarios) &&
        deviceCapabilities.emergencySubscenarios.length > 0
          ? deviceCapabilities.emergencySubscenarios
          : scenarios[nextScenario] || [];
      setSubscenario(opts[0] || "pr1_check");
    } else if (nextScenario === "pulse_calibration") {
      const opts =
        Array.isArray(deviceCapabilities?.pulseCalibrationSubscenarios) &&
        deviceCapabilities.pulseCalibrationSubscenarios.length > 0
          ? deviceCapabilities.pulseCalibrationSubscenarios
          : scenarios[nextScenario] || [];
      setSubscenario(opts[0] || "fs1");
    } else {
      setSubscenario(scenarios[nextScenario]?.[0] || []);
    }
    setExpandScenario(false);
    setExpandSubScenario(false);
    setExpandType(false);
  }

  function changeSubScenario(subScenario) {
    setSubscenario(subScenario);
    setExpandSubScenario(false);
  }

  function changeType(type) {
    setFlushType(type);
    setExpandType(false);
  }

  return (
    <div className="flex gap-3">
      <div id="scenarioDropdown" className="relative" ref={scenarioRef}>
        <button
          disabled={isTesting}
          onClick={() => {
            setExpandScenario(!expandScenario);
            setExpandSubScenario(false);
            setExpandType(false);
          }}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{scenario}</span>
          <FaChevronDown />
        </button>
        <DropdownMenu
          open={expandScenario}
          anchorRef={scenarioRef}
          onClose={() => setExpandScenario(false)}
        >
          {Object.keys(scenarios).map((sc, i) => (
            <li
              key={i}
              className="py-1 whitespace-nowrap hover:bg-gray-200"
              onClick={() => changeScenario(sc)}
            >
              {sc}
            </li>
          ))}
        </DropdownMenu>
      </div>

      <div
        id="subScenarioDropdown"
        className={`relative ${!subScenarioOptions?.length && "hidden"}`}
        ref={subScenarioRef}
      >
        <button
          disabled={isTesting}
          onClick={() => {
            setExpandSubScenario(!expandSubScenario);
            setExpandScenario(false);
            setExpandType(false);
          }}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{subscenario}</span>
          <FaChevronDown />
        </button>
        <DropdownMenu
          open={expandSubScenario}
          anchorRef={subScenarioRef}
          onClose={() => setExpandSubScenario(false)}
        >
          {subScenarioOptions.map((subScenario, i) => (
            <li
              key={i}
              className="py-1 capitalize whitespace-nowrap hover:bg-gray-200"
              onClick={() => changeSubScenario(subScenario)}
            >
              {subScenario}
            </li>
          ))}
        </DropdownMenu>
      </div>

      <div
        id="typeDropdown"
        className={`relative ${scenario !== "check_request" && "hidden"}`}
        ref={typeRef}
      >
        <button
          disabled={isTesting}
          onClick={() => {
            setExpandType(!expandType);
            setExpandScenario(false);
            setExpandSubScenario(false);
          }}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{flushType}</span>
          <FaChevronDown />
        </button>
        <DropdownMenu
          open={expandType}
          anchorRef={typeRef}
          onClose={() => setExpandType(false)}
        >
          {["check", "change", "replace"].map((t, i) => (
            <li
              key={i}
              className="py-1 capitalize whitespace-nowrap hover:bg-gray-200"
              onClick={() => changeType(t)}
            >
              {t}
            </li>
          ))}
        </DropdownMenu>
      </div>
    </div>
  );
}
